import axios from "axios";

axios.defaults.baseURL = 'https://api.quickpay.pe/api/';
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
